import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "name-cell" }
const _hoisted_2 = { class: "name-cell__tooltip-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.value), 1),
    (_ctx.showTooltip)
      ? (_openBlock(), _createBlock(_component_Tooltip, {
          key: 0,
          nameIcon: "alertCircle",
          position: "right",
          triggers: ['hover', 'click'],
          class: "name-cell__tooltip"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.tooltipText), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}